import { render } from "./ComentariosFiltro.vue?vue&type=template&id=f64d07c0&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"asignarValor\":\"options\",\"asignarSector\":\"options\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ComentariosFiltro.vue?vue&type=script&lang=js"
export * from "./ComentariosFiltro.vue?vue&type=script&lang=js"
script.render = render

export default script